import React, { useState, useEffect, useRef } from 'react'
import sparkle from '../images/sparkle-white.png'
import logo from '../images/logo.png'
import campaign_woman from '../images/campaign woman.jpg'
import video_camera from '../components/VideoCamera.svg'
import harvard from '../images/harvard.png'
import { useNavigate } from 'react-router-dom'
import ats from '../images/ats.webp'
import { useLocation } from "react-router-dom";
import single_pyramid from '../images/single_pyramid.png'
import multiple_pyramid from '../images/multiple_pyramid.png'
import mckinsey from '../images/mckinsey.png'
import campaign_woman_2 from '../images/campaign_woman_2.jpeg'
import table2 from '../images/table2.png'
import eight from '../images/eight.webp'
import imagery_3 from '../images/Imagery (2).webp'
import campaign_phone from '../images/campaign_phone.webp'
import live from '../images/live.png'
import tick from '../images/black-check-tick-icon-4 1.webp'
import whatsapp from '../images/whatsapp.png'
import depth from '../images/indepth.png'
import epic_logo from '../images/epic.png'
import vcs_logo from '../images/VCS.png'
import infinity from '../images/infinity_symbol.png'
import eightseven from '../images/87.webp'
import axios from 'axios'
import mahindra_logo from '../images/mahindra.png'
import Media_logo from '../images/MediaAnt.png'
import eno_logo from "../images/eno.png"
import good_logo from "../images/good.png"
import byd_logo from "../images/byd.webp"
import talreso_logo from "../images/talreso.png"
import job_board from '../images/job_boards.png'
import { TailSpin } from 'react-loader-spinner'
const Campaign = () => {
    const [loading, setLoading] = useState(false)
    const [invalidEmail, setInvalidEmail] = useState(false)
    const [invalidPnum, setInvalidPnum] = useState(false)
    const navigate = useNavigate()
    const sendEmail = () => {
        setLoading(true)
        axios.post(`https://northstarz.ai/v1/company/earlyaccess`, {
            "name": name,
            "email": email,
            "phone": pnum,
            "organization": company,
            "message": "",
            "utm_source": utmSource,
            "utm_medium": utmMedium,
            "utm_campaign": utmCampaign,
            "utm_term": "",
            "utm_content": utmContent
        })
            .then((response) => {
                console.log(response)
                window.dataLayer.push({ 'event': "thank you page" })
                setLoading(false)
                navigate("/thankyou_campaign")
            })
            .catch((error) => {
                console.log(error)
                alert('Something went wrong, please try again later')
                setLoading(false)
            })
    }
    const [faq, setFaq] = useState([
        {
            "question": "How does Northstarz.Ai help small HR teams?",
            "answer": "Northstarz.Ai automates screening, scheduling, and shortlisting—so you can focus on top candidates instead of sorting through 100s of resumes.",
            "isOpen": false
        },
        {
            "question": "Will AI interviews replace recruiters?",
            "answer": "No! Northstarz.Ai enhances your hiring team by handling repetitive tasks, allowing recruiters to focus on engaging and hiring top talent.",
            "isOpen": false
        },
        {
            "question": "How does the AI interview work?",
            "answer": "Candidates answer custom AI-driven interview questions, and our system analyzes responses in real time, generating detailed candidate reports with hiring insights.",
            "isOpen": false
        },
        {
            "question": "What if a candidate prefers a human interview?",
            "answer": "Northstarz.Ai doesn’t replace human interaction it accelerates screening so recruiters spend more time with the best candidates.",
            "isOpen": false
        },
        {
            "question": "Does Northstarz.Ai work with my ATS?",
            "answer": "Yes! Northstarz.Ai integrates with leading ATS platforms, ensuring all candidate data stays in one place",
            "isOpen": false
        },
        {
            "question": "How quickly can I start using Northstarz.Ai?",
            "answer": "You can start within minutes! Just upload your job descriptions, and our AI begins screening candidates immediately no setup required.",
            "isOpen": false
        },
        {
            "question": "Can I see Northstarz.Ai in action before buying?",
            "answer": "Of course! Book a free demo, and we’ll show you exactly how it works, tailored to your hiring needs.",
            "isOpen": false
        },

    ])

    const [email, setEmail] = useState("")
    const [adsDetails, setAdsDetails] = useState({})
    const [name, setName] = useState("");
    const [company, setCompany] = useState("")
    const [pnum, setPnum] = useState("")
    const [utmSource, setUtmSource] = useState("")
    const [utmMedium, setUtmMedium] = useState("")
    const [utmCampaign, setUtmCampaign] = useState("")
    const [utmContent, setUtmContent] = useState("")

    const customers = useRef()
    const hire = useRef()

    const handleClick = (index) => {
        const copy = structuredClone(faq)
        const updatedObject = faq[index]
        updatedObject.isOpen = !updatedObject.isOpen;
        copy.splice(index, 1, updatedObject)
        setFaq(copy)
    }

    const [modalOpen, setModalOpen] = useState(false)

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    let query = useQuery()
    const scrollToSection = (ref) => {
        ref.current?.scrollIntoView({ behavior: 'smooth', });
    };

    useEffect(() => {
        if (query.get('section')) {
            let sec = query.get('section')
            if (sec == 'customers') {
                scrollToSection(customers)
            }
            else if (sec == "hire") {
                scrollToSection(hire)
            }
        }
        if (query.get('utm_source')) {
            setUtmSource(query.get('utm_source'))
        }
        if (query.get('utm_medium')) {
            setUtmMedium(query.get('utm_medium'))
        }
        if (query.get('utm_campaign')) {
            setUtmCampaign(query.get('utm_campaign'))
        }
        if (query.get('utm_content')) {
            setUtmContent(query.get('utm_content'))
        }
    }, [query])

    console.log(adsDetails)

    useEffect(() => {
        if (email.length > 0) {
            if (
                email.toLowerCase().includes('gmail') ||
                email.toLowerCase().includes('yahoo') ||
                email.toLowerCase().includes('outlook') ||
                email.toLowerCase().includes('hotmail') ||
                email.toLowerCase().includes('yopmail')
            ) {
                setInvalidEmail(true)
            }
            else {
                setInvalidEmail(false)
            }
        }
    }, [email])

    useEffect(() => {
        if (pnum.length > 0) {
            if (
                isNaN(pnum) || pnum.length != 10
            ) {
                setInvalidPnum(true)
            }
            else {
                setInvalidPnum(false)
            }
        }
    }, [pnum])

    return (
        <div>
            {
                modalOpen &&
                <div className="fixed font-poppins z-50 w-2/3 md:w-1/2 p-5 left-1/2 top-1/2   rounded-2xl -translate-x-1/2 bg-[#fff8ea]  -translate-y-1/2">

                    <div className="text-right mb-3">
                        <button onClick={() => { setModalOpen(false) }} className="">
                            X
                        </button>
                    </div>
                    <div className="md:flex items-center">
                        <div className="md:w-1/2 text-center">
                            <div className=" ">
                                <p className="text-white px-5 text-xl md:text-3xl inline bg-gradient-to-r py-2  rounded-[6px] from-[#2A2A71] to-[#A080F8]   text-center">Book a demo</p>
                                <p className="my-5">Schedule a 15-min demo with our experts</p>
                            </div>
                        </div>
                        <div className="md:w-1/2 space-y-4">
                            <input value={email} onChange={(e) => { setEmail(e.target.value) }} className="outline-none md:py-6 py-3 md:px-2 px-1 w-full rounded-lg " placeholder='Work email:'></input>
                            {
                                invalidEmail &&
                                <p className="font-thicboi font-bold text-xs">Please use a valid company email address.</p>
                            }
                            <input value={name} onChange={(e) => { setName(e.target.value) }} className="outline-none md:py-6 py-3 md:px-2 px-1 w-full rounded-lg " placeholder='Full name:'></input>
                            <input value={company} onChange={(e) => { setCompany(e.target.value) }} className="outline-none md:py-6 py-3 md:px-2 px-1 w-full rounded-lg " placeholder='Company:'></input>
                            <input value={pnum} onChange={(e) => { setPnum(e.target.value) }} className="outline-none md:py-6 py-3 md:px-2 px-1 w-full rounded-lg " placeholder='Phone no:'></input>
                            {
                                invalidPnum &&
                                <p className="font-thicboi font-bold text-xs">Please enter a valid number.</p>
                            }
                            <div className="text-center">
                                <button
                                    onClick={sendEmail}
                                    disabled={!(email.length > 0 && name.length > 0 && company.length > 0 && pnum.length > 0 && !invalidEmail && !invalidPnum)} className={
                                        (email.length > 0 && name.length > 0 && company.length > 0 && pnum.length > 0 && !invalidEmail && !invalidPnum) ?
                                            "text-white px-5 text-xl inline bg-gradient-to-r  rounded-[6px] from-[#2A2A71] to-[#A080F8] py-2  text-center"
                                            : "text-white px-5 text-xl inline bg-gray-400  rounded-[6px] py-2  text-center"
                                    }>
                                    {loading ? (
                                        <TailSpin height="40" width="40" color="black" />
                                    ) : (
                                        "Request a demo"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div className={modalOpen ? "bg-[#a484fc] blur-xl w-full min-h-screen font-poppins" : "bg-[#a484fc]  w-full min-h-screen font-poppins"}>
                <div className="relative rounded-b-3xl shadow-lg px-4 md:px-20 py-20 md:space-x-20 md:flex items-center justify-center bg-gradient-to-b to-[#191E5B] from-[#A787FF]">
                    <img loading='lazy' src={sparkle} className="absolute h-20 left-1/3 top-2 opacity-[34%]"></img>
                    <img loading='lazy' src={sparkle} className="absolute h-12 -left-4 top-1/2 opacity-[53%]"></img>
                    <img loading='lazy' src={sparkle} className="absolute h-10 left-1/2 bottom-3 "></img>
                    <div className="md:w-1/2">
                        <p className="md:text-4xl text-3xl md:text-left text-center font-semibold leading-[2.3rem] md:leading-[3.5rem] text-white">Identify <span className="font-extrabold text-[#01063E]"><span className="md:text-5xl text-4xl">the best candidates </span><span className="md:text-6xl text-4xl">87%</span></span> faster with AI video interview</p>
                        <p className="md:mt-5 mt-2 text-white text-center px-6 md:px-0 md:text-left md:text-xl">Screen 8X more applicants & discover the top candidates in just 15 minutes, with zero human intervention.</p>
                        <button className="mt-5 md:block hidden bg-white text-[#01063E] rounded-lg px-5 py-2 text-lg font-semibold" onClick={() => { setModalOpen(true) }}><p className="">Book a demo</p></button>
                        <img loading='lazy' src={logo} className="h-8 md:block hidden mt-10"></img>
                    </div>
                    <div className="md:w-1/2 mt-5 px-10 md:mt-0">
                        <div>
                            <div className="bg-[#705cac] rounded-2xl px-5 py-3">
                                <div className="flex items-center space-x-2">
                                    <img loading='lazy' src={video_camera} className="h-10"></img>
                                    <img loading='lazy' src={logo} className="h-6"></img>
                                </div>
                                <div className="relative">
                                    <img loading='lazy' src={campaign_woman} className="rounded-2xl"></img>
                                    <div className="absolute top-4 left-2">
                                        <div className="flex items-center space-x-1 md:space-x-2">
                                            <div className="bg-[#E78F8F] p-1 rounded-full"></div>
                                            <div className="bg-[#E78F8F] p-1 text-white bg-opacity-80 rounded-[6px] text-[0.5rem] md:text-xs">Recording 03:10</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-center">
                        <button className="mt-10 mx-auto block md:hidden bg-white text-[#01063E] rounded-lg px-5 py-2 text-lg font-semibold" onClick={() => { setModalOpen(true) }}><p className="">Book a demo</p></button>
                        <img loading='lazy' src={logo} className="h-8 block md:hidden mx-auto mt-10"></img>
                    </div>
                </div>
                <div className="mt-5 bg-gradient-to-r py-20 md:px-40 px-3 relative md:grid md:gap-4 items-start  rounded-3xl shadow-lg from-[#A484FC] to-[#202364]">
                    <img loading='lazy' src={sparkle} className="absolute h-16 left-1/3 top-1/3 md:block hidden opacity-[34%]"></img>
                    {/* <div className="z-20 h-full">
                    <img loading='lazy' src={harvard} className="md:h-36 h-20 mx-auto md:mx-0"></img>
                    <p className="md:mt-12 mt-4 text-4xl md:text-6xl font-semibold text-center md:text-left text-white">46%</p>
                    <p className='md:mt-10 mt-4 text-sm md:text-left  text-center md:text-2xl md:leading-[3rem] leading-[1.7rem] text-white'>Companies using AI in their hiring process achieve more successful hires</p>
                </div>
                <div className="z-20 h-full">
                    <img loading='lazy' src={mckinsey} className=' mt-0 mx-auto md:mx-0 md:h-auto md:-mt-20 h-36'></img>
                    <p className="text-4xl -mt-4 md:text-6xl font-semibold md:-mt-12  text-center md:text-left text-white">20%</p>
                    <p className='md:mt-12 mt-4 text-sm md:text-2xl md:leading-[3rem] leading-[1.7rem] text-center md:text-left text-white'>More efficient hiring with AI-powered tools, helping businesses scale faster and smarter</p>
                </div> */}
                    <div className="grid grid-cols-2 gap-5 md:gap-10 w-full ">
                        <div>
                            <img loading='lazy' src={harvard} className="md:h-36 h-20 mx-auto md:mx-0"></img>
                        </div>
                        <div>
                            <img loading='lazy' src={mckinsey} className=' mt-0 mx-auto md:mx-0 md:h-28  h-16'></img>
                        </div>
                        <div>
                            <p className=" text-4xl md:text-6xl font-semibold text-center md:text-left text-white">46%</p>
                        </div>
                        <div>
                            <p className="text-4xl  md:text-6xl font-semibold -mt-1 text-center md:text-left text-white">20%</p>
                        </div>
                        <div>
                            <p className=' text-sm md:text-left  text-center md:text-2xl md:leading-[3rem] leading-[1.7rem] text-white'>Companies using AI in their hiring process achieve more successful hires</p>
                        </div>
                        <div>
                            <p className=' text-sm md:text-2xl md:leading-[3rem] leading-[1.7rem] text-center md:text-left text-white'>More efficient hiring with AI-powered tools, helping businesses scale faster and smarter</p>
                        </div>

                    </div>
                </div>

                <div className="mt-5 rounded-3xl shadow-lg from-[#A081F8] to-[#14194B] bg-gradient-to-r">
                    <div className="md:px-36 px-5 py-20 ">
                        <p className="text-3xl text-center text-white font-semibold ">Hiring challenges for fast growing companies</p>
                        <div className="md:grid md:grid-cols-2 items-center space-y-4 md:space-y-0 gap-16 mt-16">
                            <div className="bg-white py-3 px-4 md:rounded-full rounded-lg text-center text-[#001C64]">
                                <p className=" text-sm md:text-2xl font-semibold">Too many resumes, not enough time</p>
                            </div>
                            <div className="bg-white py-3 px-4 md:rounded-full rounded-lg text-center text-[#001C64]">
                                <p className="text-sm md:text-2xl font-semibold">Difficult to identify top candidates</p>
                            </div>
                            <div className="bg-white py-3 px-4 md:rounded-full rounded-lg text-center text-[#001C64]">
                                <p className=" text-sm md:text-2xl font-semibold">Hours lost in call outs to candidates</p>
                            </div>
                            <div className="bg-white py-3 px-4 md:rounded-full rounded-lg text-center text-[#001C64]">
                                <p className=" text-sm md:text-2xl font-semibold">Hiring delays means lost candidates</p>
                            </div>
                        </div>
                        <div className="bg-white mx-auto mt-4 md:mt-16 md:w-1/2 py-3 px-4 md:rounded-full rounded-lg text-center text-[#001C64]">
                            <p className=" text-sm md:text-2xl font-semibold">Small HR teams, multiple tasks</p>
                        </div>
                    </div>

                    <div className="bg-white  shadow-xl mt-0 md:mt-10 rounded-3xl py-10 px-4 md:px-20">
                        <p className="italic text-[#001C64] font-semibold text-center text-xl md:text-2xl">With Northstarz.Ai, you can</p>
                        <div className="md:grid mt-10 md:grid-cols-3 space-y-4 md:space-y-0 gap-10 md:px-20 ">
                            <div className="bg-[#2C2969] py-2 rounded-2xl text-center text-white">
                                <p className="my-5 text-sm md:text-2xl font-semibold">Build your A-Team</p>
                                <p className="text-white text-xs md:text-base pb-5">With expert trained AI models</p>
                            </div>

                            <div className="bg-[#2C2969] py-2 px-2 rounded-2xl text-center text-white">
                                <p className="my-5 text-sm md:text-2xl font-semibold"> Identify functional fitment</p>
                                <p className="text-white text-xs md:text-base pb-5">with human eye resume evaluation & Ai run technical interviews</p>
                            </div>

                            <div className="bg-[#2C2969] py-2 px-2 rounded-2xl text-center text-white">
                                <p className="my-5 text-sm md:text-2xl font-semibold">Hire 87% faster</p>
                                <p className="text-white text-xs md:text-base pb-5">with AI-powered shortlisting & decision-making</p>
                            </div>
                        </div>
                    </div>

                    <div ref={hire} className="md:py-20 py-5 md:px-36 px-10 flex justify-between items-center">
                        <p className="text-white font-bold leading-[1.7rem] md:leading-[3.7rem] text-xl md:text-4xl w-1/2">Hire the right people faster without increasing HR workload?</p>
                        <button className="bg-white md:rounded-full rounded-lg mt-5 md:mt-0 py-5 px-2 md:px-7 text-[#001C64] font-bold text-sm md:text-3xl" onClick={() => { setModalOpen(true) }}><p className="">Book a demo</p></button>
                    </div>
                </div>

                <div className="md:mt-10 mt-1 rounded-3xl px-10 md:px-40 py-20 shadow-lg from-[#13184C] to-[#987BEF] bg-gradient-to-b">
                    <p className="text-center text-xl md:text-5xl text-white font-bold">Optimize your hiring process</p>
                    <p className="text-center text-lg md:text-3xl mt-4 md:mt-10 text-white font-bold">Time & resources</p>
                    <div className="md:grid md:grid-cols-2  md:space-y-0 space-y-10 gap-10 mt-10">
                        <div className="bg-[#6050AC] p-8 h-full rounded-2xl text-center">
                            <div className="p-5 rounded-2xl justify-between flex flex-col h-full bg-gradient-to-r text-white from-[#644FAC] to-[#191C51]">
                                <p className="text-white  md:text-2xl font-semibold">Human recruiter</p>

                                <p style={{ fontWeight: "20px" }} className="mt-5 text-5xl md:text-7xl font-bold ">1 : 1</p>
                                <p className="text-white mt-5 md:text-xl  text-sm ">Concurrent interview</p>

                            </div>
                        </div>
                        <div className="bg-[#6050AC] p-8 rounded-2xl text-center">
                            <div className="p-5 rounded-2xl bg-gradient-to-r text-white from-[#644FAC] to-[#191C51]">
                                <p className="text-white  md:text-2xl font-semibold">Human recruiter with Northstarz</p>

                                <div className="flex items-center justify-center space-x-2 ">
                                    <p className="mt-5 text-5xl md:text-7xl font-bold ">1  : </p>
                                    <img loading='lazy' src={infinity} className="h-20 mt-6"></img>
                                </div>
                                <p className="text-white mt-5 md:text-xl  text-sm ">Concurrent interview</p>
                            </div>
                        </div>
                    </div>
                    <p className="text-center text-lg md:text-3xl mt-4 md:mt-10 text-white font-bold">Impact on recruitment</p>
                    <div className="grid md:grid-cols-2 md:space-y-0 space-y-10 gap-10 mt-4 md:mt-10">
                        <div className="bg-[#6050AC] h-full p-8 rounded-2xl text-center">
                            <div className="p-5 rounded-2xl h-full bg-gradient-to-r text-white from-[#644FAC] to-[#191C51]">
                                <p className="text-white  md:text-2xl font-semibold">Human recruiter</p>
                                <div className="flex items-center mt-5 justify-evenly space-x-4 my-3">
                                    <img loading='lazy' src={single_pyramid} className="md:h-28 h-16"></img>
                                    <div>
                                        <p className="text-white text-xl md:text-4xl font-bold">6-8</p>
                                        <p className="text-white mt-2 text-sm md:text-2xl ">Hires per month</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-[#6050AC] p-8 rounded-2xl text-center">
                            <div className="p-5 rounded-2xl bg-gradient-to-r text-white from-[#644FAC] to-[#191C51]">
                                <p className="text-white  md:text-2xl font-semibold">Human recruiter with Northstarz</p>
                                <div className="flex items-center mt-5 justify-evenly space-x-4 my-3">
                                    <img loading='lazy' src={multiple_pyramid} className="md:h-28 h-16"></img>
                                    <div>
                                        <p className="text-white text-xl md:text-4xl font-bold">18-20</p>
                                        <p className="text-white mt-2 text-sm md:text-2xl ">Hires per month</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-center">
                        <button className="mt-20 bg-white text-[#01063E] rounded-lg px-7 py-3 text-2xl font-semibold" onClick={() => { setModalOpen(true) }}><p className><p className="">Book a demo</p></p></button>
                    </div>
                </div>

                <div >
                    <div className=" pb-10">
                        <p className="text-center customGradient mb-5 font-bold text-xl mt-2 md:mt-0 px-4 md:px-0 md:text-5xl text-white py-3 md:py-10">AI-powered hiring in 3 steps</p>
                        <div className=" bg-white rounded-lg  md:rounded-[123px] py-10 px-4 md:px-20 md:flex items-center md:space-y-0 space-y-10 space-x-0 md:space-x-20">
                            <div className="relative md:w-1/2  order-last md:order-first">
                                <div className="bg-gradient-to-r top-1/2 shadow-2xl left-4 -translate-y-1/2 absolute rounded-[51px] from-[#6C55B5] to-[#151950] opacity-70 md:w-[550px]  md:h-[265px]"></div>
                                <div className="md:absolute relative shadow-2xl md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2  ">
                                    <img loading='lazy' src={campaign_woman_2} className="rounded-2xl h-40 mx-auto aspect-auto md:h-60"></img>
                                    <div className="absolute top-4 left-2">
                                        <div className="flex items-center space-x-1 md:space-x-2">
                                            <div className="bg-[#E78F8F] p-1 rounded-full"></div>
                                            <div className="bg-[#E78F8F] p-1 text-white bg-opacity-80 rounded-[6px] text-[0.5rem] md:text-xs">Recording 03:10</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="second_box mx-auto hidden md:block shadow-2xl"></div>
                            </div>
                            <div className="md:w-1/2 text-center md:text-left">
                                <p className="text-[#002675] text-2xl md:text-4xl font-bold">AI video screening</p>
                                <p className="text-[#002473]  md:text-xl px-5 md:px-0 text-sm mt-2 md:mt-5">Candidates have live conversations with our AI recruiter, answering job-relevant questions.</p>
                            </div>
                        </div>

                        <div className="mt-5 bg-white rounded-lg  md:rounded-[123px] py-10 px-4 md:px-20 md:flex items-center md:space-y-0 space-y-10 space-x-0 md:space-x-20">
                            <div className="relative md:w-1/2">
                                <div className="bg-gradient-to-r top-1/2 hidden md:block shadow-2xl left-4  -translate-y-1/2 absolute rounded-[51px] from-[#6C55B5] to-[#151950] opacity-70 w-[550px] h-[265px]"></div>
                                <img loading='lazy' src={table2} className="md:absolute relative shadow-2xl md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 h-40 mx-auto md:h-72 rounded-l-xl"></img>
                                <div className="second_box mx-auto hidden md:block shadow-2xl"></div>
                            </div>
                            <div className="md:w-1/2 text-center md:text-left">
                                <p className="text-[#002675] text-2xl md:text-4xl font-bold">Automated shortlisting</p>
                                <p className="text-[#002473] md:text-xl px-5 md:px-0 text-sm mt-2 md:mt-5">AI evaluates responses, covering qualifications, employability skills, and technical fit to rank candidates.</p>
                            </div>
                        </div>

                        <div className="mt-5 bg-white rounded-lg  md:rounded-[123px] py-10 px-4 md:px-20 md:flex items-center md:space-y-0 space-y-10 space-x-0 md:space-x-20">
                            <div className="relative md:w-1/2">
                                <div className="bg-gradient-to-r top-1/2 hidden md:block shadow-2xl left-1/2 -translate-x-1/2 -translate-y-1/2 absolute rounded-[51px] from-[#6C55B5] to-[#151950] opacity-70 w-[550px] h-[265px]"></div>
                                <img loading='lazy' src={imagery_3} className="md:absolute mx-auto relative shadow-2xl md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 h-[26rem] rounded-l-xl"></img>
                                <div className="second_box mx-auto hidden md:block shadow-2xl"></div>
                            </div>
                            <div className="md:w-1/2 text-center md:text-left">
                                <p className="text-[#002675] text-2xl md:text-4xl font-bold">Actionable design for insights</p>
                                <p className="text-[#002473] md:text-xl px-5 md:px-0 text-sm mt-2 md:mt-5">AI evaluates responses, covering qualifications, employability skills, and technical fit to rank candidates.</p>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="text-center py-4 md:py-">
                    <button className="md:mt-2 bg-white text-[#01063E] rounded-lg px-10 py-3 text-xl font-semibold" onClick={() => { setModalOpen(true) }}><p className><p className="">Book a demo</p></p></button>
                </div>

                <div className="bg-gradient-to-b md:grid md:grid-cols-2 items-center  pt-1 md:pt-10 md:px-36 rounded-lg md:rounded-[123px] from-[#DACCFF] to-[#161A51]">
                    <div >
                        <p className="md:text-6xl text-xl md:mt-0 px-6 md:px-0 text-white font-bold md:leading-[5rem]  mt-10  md:text-left text-center">AI-powered features that make hiring effortless</p>
                    </div>
                    <div>
                        <img loading='lazy' src={campaign_phone} className=''></img>
                    </div>
                </div>

                <div className="bg-gradient-to-t  mt-10 py-5 md:py-20 px-4 md:px-40 rounded-lg md:rounded-[123px] from-[#DACCFF] to-[#161A51]">
                    <div className=" md:grid md:grid-cols-2 gap-10 space-y-10 md:space-y-0 items-start">
                        <div>
                            <div className="flex space-x-2 items-center">
                                <img loading='lazy' src={live} className="md:h-10 h-5 w-5 invert md:w-10"></img>
                                <p className="text-[#FF9EF5] text-lg md:text-2xl font-semibold">Live AI video interviews</p>
                            </div>
                            <div className="mt-5 space-y-4 text-white">
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Basic qualifications & experience</p>
                                </div>
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Technical knowledge & role-fit</p>
                                </div>
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Employability skills & communication ability</p>
                                </div>
                            </div>
                        </div>
                        <div className="md:mt-20 mt-10">
                            <div className="flex space-x-2 items-center">
                                <img loading='lazy' src={depth} className="md:h-10 h-5 w-5 invert md:w-10"></img>
                                <p className="text-[#FF9EF5] text-lg md:text-2xl font-semibold">In-depth candidate insights</p>
                            </div>
                            <div className="mt-5 space-y-4 text-white">
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Candidate skills, experience & role fit</p>
                                </div>
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Behavioral & employability skill analysis</p>
                                </div>
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">AI-powered recommendations for next steps</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="flex space-x-2 items-start">
                                <img loading='lazy' src={whatsapp} className="md:h-10 h-5 w-5  md:w-10"></img>
                                <p className="text-[#FF9EF5] text-lg md:text-2xl font-semibold">AI runs interviews, automated Whatsapp follow-ups</p>
                            </div>
                            <div className="mt-5 space-y-4 text-white">
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">AI conducts interviews at candidates’ preferred times 24/7</p>
                                </div>
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Sends automatic reminders & follow ups over email and whatsapp</p>
                                </div>
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Employability skills & communication ability</p>
                                </div>
                            </div>
                        </div>
                        <div className="mt-10">
                            <div className="flex space-x-2 items-center">
                                <img loading='lazy' src={ats} className="md:h-10 h-5 w-5 invert md:w-10"></img>
                                <p className="text-[#FF9EF5] text-lg md:text-2xl font-semibold">All in your ATS</p>
                            </div>
                            <div className="mt-5 space-y-4 text-white">
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Stay in their existing systems</p>
                                </div>
                                <div className="flex items-start justify-start space-x-2">
                                    <img loading='lazy' src={tick} className="h-5"></img>
                                    <p className="md:text-xl text-sm">Access actionable insights without extra admin work</p>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="text-center ">
                        <button className="mt-10 bg-white text-[#01063E] rounded-lg px-7 py-3 text-lg md:text-2xl font-semibold" onClick={() => { setModalOpen(true) }}><p className><p className="">Book a demo</p></p></button>
                    </div>

                </div>

                <div ref={customers} className="bg-gradient-to-b py-5 md:py-20 px-10 md:px-40 from-[#A484FC] rounded-lg md:rounded-b-[123px] to-[#141851] ">
                    <div className="md:flex  items-center space-x-10 text-center md:text-left">
                        <p className="md:text-4xl text-xl font-semibold text-white">Real hiring results</p>
                        <p className="md:text-4xl text-lg text-[#002A7F] font-semibold bg-white py-2 md:mt-0 mt-2  md:py-5 px-4 rounded-xl">What our customers say</p>
                    </div>

                    <div className="md:mt-10 mt-2">
                        <div className="bg-[#0F1232] text-xs md:text-xl px-3 py-4 italic rounded-xl text-white">
                            <p className="font-[100]">“We went from screening candidates in weeks to just hours. AI video interviews <b className="font-bold">saved</b> us over <b className="font-bold">20+ hours per hire</b>.”</p>
                        </div>
                        <p className="text-white text-sm md:text-xl  text-right mt-2 md:mt-5">-Sanjay Gawde (CHRO)</p>
                    </div>

                    <div className="md:mt-10 mt-2">
                        <div className="bg-[#0F1232] text-xs md:text-xl px-3 py-4 italic rounded-xl text-white">
                            <p className="font-[100]">“Our small HR team now hires like an enterprise, without adding recruiters. AI scheduling & screening changed everything.”</p>
                        </div>
                        <p className="text-white text-sm md:text-xl text-left mt-2 md:mt-5">-Pankaj Jha (EPIC Investment Partners)</p>
                    </div>

                    <div className="md:grid md:grid-cols-2 gap-10 mt-4 md:mt-20">
                        <div className=" bg-gradient-to-b h-full text-white from-[#6C55B5] to-[#141853] p-4 md:p-8 rounded-2xl text-center">
                            <div className="md:p-5 justify-center  flex flex-col h-full p-2 rounded-2xl bg-[#6050AC]">
                                <div className="flex md:px-0  items-center mt-5 justify-between space-x-4 my-3">
                                    <div className="flex items-center">
                                        <img loading='lazy' src={eightseven} className="h-20"></img>
                                        <p className="italic -ml-4 text-5xl">%</p>
                                    </div>
                                    <div>
                                        <p className="text-white md:ml-0 -translate-x-4 md:-translate-x-8 text- md:text-4xl italic ">faster hiring</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className=" bg-gradient-to-b mt-5 md:mt-0 text-white from-[#6C55B5] to-[#141853] p-4 md:p-8 rounded-2xl text-center">
                            <div className="md:p-5 p-2 rounded-2xl bg-[#6050AC]">
                                <div className="flex items-center mt-5 justify-evenly space-x-4 my-3">
                                    <img loading='lazy' src={eight} className="h-24"></img>
                                    <div>
                                        <p className="text-white text- md:text-4xl italic ">more candidates screened</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="md:py-20 py-5 px-2  md:px-10 bg-gradient-to-b from-[#A484FC] to-[#161954]">
                    <p className="md:text-4xl text-2xl text-[#141853] font-bold text-center"><span className="text-white">Why</span> growing companies <span className="text-white">choose</span> Northstarz.Ai</p>

                    <div className="md:mt-10 mt-2 ">
                        <div className="flex flex-col  space-y-5">
                            <div className="flex justify-between items-center px-2 md:px-10 rounded-lg bg-[#8C77D6] py-2 shadow-2xl">
                                <div className="md:w-1/4 w-1/4 py-5 mx-auto">
                                    <p className="text-white inline   w-full bg-[#141853] shadow-xl rounded-lg px-2 md:px-3 text-xs md:text-3xl py-2 ">Features</p>
                                </div>
                                <div className="w-1/3 text-center py-2 mx-auto ">
                                    <p className="text-white inline   w-full bg-[#141853] shadow-xl rounded-lg px-1 md:px-3 text-xs md:text-3xl py-2 ">Traditional hiring</p>
                                </div>
                                <div className="w-1/3 text-center py-2 mx-auto">
                                    <p className="text-white inline  text-center w-full bg-[#141853] shadow-xl rounded-lg px-2 text-xs  md:px-3 md:text-3xl py-2 ">Northstarz.Ai</p>
                                </div>
                            </div>
                            <div className="flex justify-between px-2 md:px-10 rounded-lg bg-[#6852B2] py-5  shadow-2xl">
                                <p className="text-white text-xs md:text-2xl py-5 w-1/4 ">Candidate engagement</p>
                                <p className="w-1/3  text-center text-xs md:text-2xl py-5 ">Manual emails & slow responses</p>
                                <p className="w-1/3 text-white text-left text-xs md:text-2xl py-5 ">24/7 AI-driven interviews & follow-ups</p>
                            </div>
                            <div className="flex justify-between px-2 md:px-10 rounded-lg bg-[#8C77D6] py-5 shadow-2xl">
                                <p className="text-xs text-white  md:text-2xl py-5 w-1/4 ">Identify intelligence</p>
                                <p className="w-1/3  text-center text-xs md:text-2xl py-5 ">Subjective judgment</p>
                                <p className="w-1/3  text-white text-left text-xs md:text-2xl py-5 ">Mimics industry experts to identify top talent</p>
                            </div>
                            <div className="flex justify-between px-2 md:px-10 rounded-lg bg-[#6852B2] py-5  shadow-2xl">
                                <p className="text-white text-xs md:text-2xl py-5 w-1/4 ">Screening process</p>
                                <p className="w-1/3  text-center text-xs md:text-2xl py-5 ">Hours sorting resumes</p>
                                <p className="w-1/3 text-left  text-white text-xs md:text-2xl py-5 ">AI shortlists top candidates in minutes</p>
                            </div>
                            <div className="flex justify-between px-2 h-full md:px-10 rounded-lg bg-[#8C77D6] py-5 shadow-2xl">
                                <p className="text-xs text-white  md:text-2xl py-5 w-1/4 ">Hiring Speed</p>
                                <p className="w-1/3  text-center text-xs md:text-2xl py-5 ">Weeks to shortlist</p>
                                <p className="w-1/3 text-left  text-white text-xs md:text-2xl py-5 ">87% faster hiring</p>
                            </div>
                            <div className="flex justify-between px-2 md:px-10 rounded-lg bg-[#6852B2] py-5  shadow-2xl">
                                <p className="text-xs text-white  md:text-2xl py-5 w-1/4 ">Recruiter Workload</p>
                                <p className="w-1/3  text-center text-xs md:text-2xl py-5 ">Overwhelmed with admin tasks</p>
                                <p className="w-1/3 text-left  text-white text-xs md:text-2xl py-5 ">AI automates screening, reports & scheduling</p>
                            </div>
                            <div className="flex justify-between px-2 md:px-10 rounded-lg bg-[#8C77D6] py-5 shadow-2xl">
                                <p className="text-white text-xs md:text-2xl py-5 w-1/4 ">Cost Efficiency</p>
                                <p className="w-1/3  text-center text-xs md:text-2xl py-5 ">High agency & job board spend</p>
                                <b className="w-1/3 text-left  text-white  text-xs md:text-2xl py-5 ">70% lower hiring costs</b>
                            </div>


                        </div>
                    </div>
                </div>


                <div className="md:py-20 py-7 bg-gradient-to-b from-[#8A66F4]  to-[#151854] px-4 md:px-36 md:flex justify-between items-center">
                    <p className="text-white font-bold leading-[1.7rem] md:leading-[90px] text-2xl px-2 md:text-5xl text-center md:text-left md:w-1/2">Find your next hire in hours not weeks</p>
                    <div className="text-center md:text-left md:mt-0 mt-5">
                        <button className="bg-white md:rounded-full rounded-lg py-2 md:py-5 px-7 text-[#001C64] font-bold text-xl text-center md:text-3xl" onClick={() => { setModalOpen(true) }}><p className="">Book a demo</p></button>
                    </div>
                </div>

                <div className="md:py-20 py-5 px-4 md:px-36">
                    <p className="text-2xl text-white italic  block mb-10 text-center ">Trusted By</p>
                    <div className="flex items-center justify-evenly space-x-1 md:space-x-10">
                        {/* <p className="text-2xl text-white italic md:block hidden">Trusted By</p> */}
                        <img loading='lazy' src={mahindra_logo} className="md:h-16  h-7"></img>
                        <img loading='lazy' src={epic_logo} className="md:h-16  h-7"></img>
                        <img loading='lazy' src={good_logo} className="md:h-16  h-7"></img>
                        <img loading='lazy' src={byd_logo} className="md:h-16 h-7"></img>
                    </div>

                    <div className="flex mt-5  md:mt-20 items-center justify-evenly space-x-2 md:space-x-10">
                        <img loading='lazy' src={Media_logo} className="md:h-20  h-7"></img>
                        <img loading='lazy' src={talreso_logo} className="md:h-16  h-7"></img>
                        <img loading='lazy' src={vcs_logo} className="md:h-16  h-7"></img>
                        <img loading='lazy' src={eno_logo} className="md:h-10  h-5"></img>

                    </div>
                    <div className="flex mt-5 md:mt-20 items-center justify-evenly space-x-2 md:space-x-10">
                    </div>
                </div>

                <div className="bg-gradient-to-b from-[#936BFF] to-[#191A59] py-5 md:py-20 px-4  md:px-36 rounded-lg md:rounded-[123px]">
                    <div className="md:flex space-y-5 md:space-y-0 justify-between items-center">
                        <div className=" md:w-1/2 ">
                            <p className="md:text-5xl text-xl text-center md:text-left mt-4 md:mt-0 text-white font-semibold">Integrate your legacy ATS</p>
                            <p className="text-white mt-5 md:mt-10 px-2 md:px-0 text-center md:text-left text-sm md:text-xl">We seamlessly connects with your favorite ATS, so you don't have to change your workflows.</p>
                        </div>
                        <div className="relative bg-gradient-to-r md:mx-0 mx-10 from-[#967AEC] z-0 to-[#FCFEFF] rounded-lg md:rounded-[51px]">
                            <img loading='lazy' src={job_board} className="md:h-96 h-40 mx-auto z-20"></img>
                            <div className="bg-gradient-to-r from-[#967AEC] -z-10 to-[#FCFEFF] rounded-full -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 md:p-32 p-10  absolute shadow-2xl"></div>
                        </div>
                    </div>


                </div>

                <div className="bg-gradient-to-b mt-5 md:mt-5 from-[#936BFF] to-[#191A59] py-5 md:py-40 px-4 md:px-36 rounded-lg md:rounded-[123px]">
                    <div className="md:flex space-y-5  md:gap-x-6 md:space-y-0 justify-between items-center">
                        <div>
                            <p className="md:text-5xl text-xl text-center md:text-left mt-4 md:mt-0 text-white font-semibold">Drive your hiring OKRs with AI</p>
                            <p className="text-white mt-5 md:mt-10 px-2 md:px-0 text-center md:text-left text-sm md:text-xl">Schedule a 30 minute product demo with expert Q&A</p>
                        </div>
                        <div className='md:text-left text-center'>
                            <button className="bg-white rounded-lg py-2 md:py-5 px-7 text-[#001C64] font-bold text-xl md:text-3xl" onClick={() => { setModalOpen(true) }}><p className=""><p className="">Book a demo</p></p></button>
                        </div>
                    </div>



                </div>

                <div className="bg-gradient-to-b py-20 px-4 md:px-36 from-[#8A65F3] to-[#201E62]">
                    <p className="text-center text-3xl md:text-5xl italic text-white">FAQs:</p>
                    <div className="mt-10 space-y-10">
                        {
                            faq.map((q, i) => {
                                return (
                                    <div className="text-white ">
                                        <div onClick={() => { handleClick(i) }} className="bg-[#0F1232AD] cursor-pointer rounded-lg py-2 px-3">
                                            <p>{i + 1}. {q.question}</p>
                                        </div>
                                        {
                                            q.isOpen &&
                                            <div>
                                                <p className="text-white mt-2">{q.answer}</p>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <img loading='lazy' src={logo} className="mx-auto mt-20 h-10"></img>
                </div>

            </div>
        </div>
    )
}

export default Campaign